var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"footer"},[_c('span',{staticClass:"footer--text"},[_vm._v(" © Copyright 2020-"+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"/","target":"_blank","title":"Britecheck.com"}},[_vm._v("Britecheck")]),_vm._v(", All rights reserved. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }